import SBC from "@/components/organisms/SBCs/SBC/SBC";
import { fireGTMEvent } from "@/functions/fireGTMEvent";
import { showModal } from "@/redux/message/messageSlice";
import {
  Sbc,
  getSbcSetSelector,
  getSbcsSelector,
  markSbcSolved, // setCurrrentSbc,
  // setCurrrentSbcSet,
  solveSbc,
} from "@/redux/sbcs/sbcsSlice";
import { AppDispatch } from "@/redux/store";
import { getUserSelector } from "@/redux/user/userSlice";
import { BREAKPOINTS } from "@/settings";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { NavLink } from "react-router-dom";
import { useMediaQuery } from "usehooks-ts";

type Props = {
  sbc: Sbc;
  index: number;
  isOnSolutionsViewPage?: boolean;
  disableToggle?: boolean;
};

const GetCardSBC: React.FC<Props> = ({
  sbc,
  index,
  isOnSolutionsViewPage,
  disableToggle,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const { setId } = useParams();
  const { sbcs, sbcSetStatus } = useSelector(getSbcsSelector);
  const sbcSet = useSelector(getSbcSetSelector(+setId));
  const { user } = useSelector(getUserSelector);

  const isMobile = useMediaQuery(BREAKPOINTS.TOUCH_DEVICE.query);

  useEffect(() => {
    if (sbcSetStatus === "rejected") navigate("/");
    window.scrollTo(0, 0);
  }, [sbcSetStatus, navigate]);

  // Memo to avoid recalculating every render here.
  const reqHeightDifference = useMemo(() => {
    if (isMobile) return [];
    const diffs: number[] = [];
    for (let i = 0; i < sbcs.length; i++) {
      const sbc1 = sbcs[i];
      const sbc2 = sbcs[i + 1];
      const rowHeight = Math.max(
        sbc1.requirements.length,
        sbc2?.requirements?.length || 0,
      );
      diffs[i] = rowHeight - sbc1.requirements.length;
      diffs[i + 1] = rowHeight - (sbc2?.requirements?.length || 0);
      i++;
    }
    return diffs;
  }, [sbcs, isMobile]);

  const handleSBCClicked = () => {
    fireGTMEvent("clicked_solve_sbc");
    // dispatch(setCurrrentSbcSet(sbcSet));
    // dispatch(setCurrrentSbc(sbc));
    dispatch(solveSbc(sbc.id));
  };

  const card = (
    <SBC
      disableToggle={disableToggle}
      {...sbc}
      key={sbc.name}
      imageURL={sbcSet?.sbcsCount < 2 ? sbcSet?.imageURL : sbc.imageURL}
      platform={user.platform}
      reqHeightDifference={reqHeightDifference[index] ?? 0}
      isOnSolutionsPage={isOnSolutionsViewPage}
      onComplete={(completed) => {
        if (user.uuid) {
          dispatch(
            markSbcSolved({
              setId: sbc.setId,
              sbcId: sbc.id,
              solved: completed,
            }),
          );
          if (completed) {
            fireGTMEvent("clicked_completed");
          }
        } else {
          dispatch(
            showModal({
              modalType: "login-required",
              freeFeatureLoggedInRequiredHook: "complete-sbc",
            }),
          );
        }
      }}
    />
  );

  if (isOnSolutionsViewPage) {
    return <div>{card}</div>;
  }

  return (
    <NavLink
      to={`${sbc.name.replace(/ /g, "-").toLowerCase()}/${sbc.id}`}
      onClick={handleSBCClicked}
    >
      {card}
    </NavLink>
  );
};

export default GetCardSBC;
